import { OutputHTMLElement } from "components/output/baseHTMLElementOutput";
import { I18nMessageDefinition } from "components/i18n/I18nMessage";
import template from "components/output/baseInputOutput.hbs";

export class TextOutputElement extends OutputHTMLElement {

  constructor() {
    super();

    let className = "c-text-output__input o-form-component__output o-form-component__input-group__input";
    const classCSSOutput = this.getAttribute("classCSSOutput");
    if (classCSSOutput) {
      className += " " + classCSSOutput;
    }

    const optTemplate = {
      "prefixId": "to",
      "id": this.getAttribute("_id"),
      "className": className,
      "style": this.getAttribute("styleCSSOutput"),
      "disableFocusKeyboard": (this.getAttribute("disableFocusKeyboard") === 'true'),
    } as any;

    this.innerHTML = template(optTemplate);

    this.input = this.querySelector("input");
  }

  get data(): string | I18nMessageDefinition {
    let v = this.input.value;
    if (v === "") {
      return null;
    } else {
      return v;
    }
  }

  set data(v: string | I18nMessageDefinition) {
    this.input.value = v?.toString() ?? null;
    this.initialValue.value = this.data;
  }

}

export function initTextOutputWebComponent() {
  window.customElements.define("s6-text-output", TextOutputElement);
}
